import React from 'react'
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
function TipogramArtistBadge() {
  return (
        <>
               <MilitaryTechIcon className='featuredArtistsBadgeIcon featuredArtistsBadgeMilitary'/>
        </>
  )
}

export default TipogramArtistBadge